// ----
// This is where all of the site-specific JS goes. This is the site's main JS file, so make your JS defensive.
// It's created using the JS Module Pattern (http://addyosmani.com/resources/essentialjsdesignpatterns/book/#modulepatternjavascript)
// Usage: App.SiteJS.functionName();  Can be used anywhere in the application.
// ----

var App = App || {};

(function (ns, $) {

    ns.toggleRelatedContentWidget = function (trigger, target) {
        var $buttonText = 'View More';
        $(trigger).on('click', function () {
            var $this = $(this);
            var $targetElement = $this.parent().siblings(target);
            $buttonText === 'View More' ? $this.html('View Less') : $this.html('View More');
            $targetElement.slideToggle();
            $buttonText = $this.html();
        });
    };

    ns.mobileContentNav = function () {
        $('.toggle-left-col').on('click', function (e) {
            e.stopPropagation();
            $('body').addClass('on-canvas');
            $('.page-column--left').addClass('expanded');
        });
        $('.toggle-left-col__close, .info-widget-wrap a, .mobile-mask').on('click', function () {
            $('.page-column--left').removeClass('expanded');
            $('body').removeClass('on-canvas');
        });
    };

    //highlighting on scroll
    ns.scrollHighlight = function () {
        $(window).on('scroll', function () {
            var scrollTop = $(this).scrollTop();
            $('.articleClientType').each(function () {
                var topDistance = $(this).offset().top;
                var subheadingArticleId = $(this).attr('id');
                var scrollToLink = $('.section-jump-link__link-wrap a[href="#' + subheadingArticleId + '"]');
                // if section is in view
                if (topDistance - 80 < scrollTop) {
                    if ($(scrollToLink).length) {
                        $('.list-issue-jumplinks li').removeClass('active');
                    }
                    $(scrollToLink).closest('.section-jump-link').addClass('active');
                }
            });
            if ($('.article-body').length) {
                $('h2').each(function () {
                    var topDistance = $(this).offset().top;
                    var subheadingArticleId = $(this).attr('id');
                    var scrollToLink = $('.section-jump-link__link-wrap a[href="#' + subheadingArticleId + '"]');
                    // if section is in view
                    if (topDistance - 80 < scrollTop) {
                        if ($(scrollToLink).length) {
                            $('.jumplink-list li').removeClass('active');
                        }
                        $(scrollToLink).closest('.section-jump-link').addClass('active');
                    }
                });
            }
        });
    };

    // ----
    // Modals
    // ----
    // for complex modals that copy content
    ns.contentModals = function () {
        $('.table-modal').addClass('reveal-modal');
        if (!$('.pg_ArticleSplitView, .pg_articlesplitview').length) {
            $('.reveal-modal').attr('aria-hidden', 'true');
            $('a[reveal-id]').each(function () {
                var $link = $(this);
                if ($link.hasClass('xref-fn')) {

                    $link.click(function () {
                        var modalTriggerId = $(this).attr('reveal-id');
                        var $targetModal = $('.fn[content-id="' + modalTriggerId + '"]');
                        var refModalContents = $targetModal.html();
                        $('body').addClass('on-canvas');
                        $(refModalContents).clone().appendTo('#revealModal #revealContent').addClass('ref-modal');
                        var $openedModal = $('.ref-modal').closest('.reveal-modal');
                        $openedModal.addClass('open');
                        setAccesibilityAttributes($openedModal, true, modalTriggerId);
                        $openedModal.attr('tabindex', '-1');
                        $openedModal.scrollTop(0);

                        $(document.body).off('keyup.contentModals');

                        $(document.body).on('keyup.contentModals', function (e) {
                            if (e && e.code && e.code.toLowerCase() === 'escape' && $openedModal.hasClass('open')) {
                                $('.ref-modal').html('').removeClass('ref-modal');
                                closeModal($openedModal, $link);
                            }
                        });

                        $('.close-reveal-modal').on('click.contentModalsClose', function () {
                            var $openedModal = $(this).closest('.reveal-modal');
                            if ($openedModal.hasClass('open')) {
                                $('.ref-modal').html('').removeClass('ref-modal');
                                $(this).off('click.contentModalsClose');
                                closeModal($openedModal, $link);
                            }
                        });
                    });

                } else {
                    var modalTriggerId = $link.attr('reveal-id');
                    var $targetModal = $('.reveal-modal[content-id="' + modalTriggerId + '"]');
                    $link.click(function (e) {
                        if ($targetModal.length) {
                            e.stopPropagation();
                            $('body').addClass('on-canvas');
                            $targetModal.addClass('open');
                            setAccesibilityAttributes($targetModal, true, modalTriggerId);
                            $targetModal.attr('tabindex', '-1');
                            $targetModal.scrollTop(0);

                            $(document.body).off('click.contentModals keyup.contentModals');

                            $(document.body).on('click.contentModals', function () {
                                if ($targetModal.hasClass('open')) {
                                    closeModal($targetModal, $link);
                                }
                            });
                            $(document.body).on('keyup.contentModals', function (e) {
                                if (e && e.code && e.code.toLowerCase() === 'escape' && $targetModal.hasClass('open')) {
                                    closeModal($targetModal, $link);
                                }
                            });

                            $('.close-reveal-modal').on('click.contentModalsClose', function () {
                                var $openedModal = $(this).closest('.reveal-modal');
                                if ($openedModal.hasClass('open')) {
                                    $('.ref-modal').html('').removeClass('ref-modal');
                                    $(this).off('click.contentModalsClose');
                                    closeModal($openedModal, $link);
                                }
                            });
                        }
                    });
                }
            });
        }
    };

    function closeModal($modal, $trigger) {
        $modal.removeClass('open');
        $('body').removeClass('on-canvas');
        setAccesibilityAttributes($modal, false, $trigger.attr('id'));
        $(document.body).off('click.contentModals keyup.contentModals');
    }

    function setAccesibilityAttributes($modal, isOpen, modalTriggerId) {
        if (!$modal || !$modal.length) {
            return;
        }

        if (isOpen) {
            $modal.attr('aria-hidden', 'false');
            $modal.attr('aria-live', 'assertive');

            var $label = $modal.find('.label').first();

            if ($label.length) {
                var labelId = $label.attr('id');

                if (!labelId) {
                    labelId = 'modal-label-' + modalTriggerId;
                    $label.attr('id', labelId);
                }

                $modal.attr('aria-labelledby', labelId);
            } else {
                $modal.removeAttr('aria-labelledby');
            }

        } else {
            $modal.attr('aria-hidden', 'true');
            $modal.removeAttr('aria-live');
            $modal.removeAttr('aria-labelledby');
        }
    }
	
    ns.registerTrendMdOnSplitview = function () {
        SCM.Retry.policy()
            .handleResult(function (result) { return !result; }) // Retry when our execute function returns false
            .waitAndRetry(5, 2000) // Retry 5 times, waiting 2000ms between each try
            .execute(function () {
                return window.TrendMD && window.TrendMD.registerDefault;
            })
            .then(function (result) {
                window.TrendMD.registerDefault();
            })
            .catch(function (reason) {
                console.error('Timed out waiting for library to be ready.');
            });
    };

    var GeoScienceWorldLinksCalled = false;
    ns.isGeoScienceWorldLinksCalled = function () {
        return GeoScienceWorldLinksCalled;
    };

    ns.insertGeoScienceWorldLinksIntoReferences = function () {
        var $splitViewRefList = $('.js-splitview-ref-list');
        if (!$splitViewRefList.length) {
            return;
        }

        GeoScienceWorldLinksCalled = true;

        const $refContent = $splitViewRefList.find('.ref-content');
        if (!$refContent.length)
            GeoScienceWorldLinksCalled = false;

        var $referenceDois = $refContent.map(function () {
            var $linkUriDoi = $(this).find('.link-uri').first();
            if (!$linkUriDoi.length) {
                $linkUriDoi = $(this).find('.link').first();
            }
            var $links = $(this).find('.citation-links').first();
            var $url = $linkUriDoi.attr('href');
            if ($url) {
                var $splitUrl = $url.split('doi.org/');
                return { 'elem': $links, 'doi': $splitUrl[1] };
            }
        }).filter(function (index, value) { return !!value && !!value.elem && !!value.doi; });

        var $doisToLookup = $referenceDois
            .map(function (index, item) { return item.doi; })
            .get()
            .filter(function (value, index, self) {
                return self.indexOf(value) === index;
            });

        $.post('/Article/ArticleUrlsByDoi', { 'dois': $doisToLookup.toString() }).promise()
            .then(function (result) {
                if (!result || !result.Success) {
                    var d = $.Deferred();
                    d.reject(result.Messages && result.Messages.length
                        ? result.Messages[0]
                        : 'Unknown error');
                    return d;
                }
                $referenceDois.each(function (index, item) {
                    if (item.elem && item.doi && result.Result[item.doi]) {
                        var $articleLink = $('<div>')
                            .addClass('article-ref-link js-ref-link')
                            .html(
                                $('<a>')
                                    .attr('href', result.Result[item.doi])
                                    .html('GeoScienceWorld '));

                        item.elem.prepend($articleLink);
                    }
                });
            })
            .then(null,
                function (err) {
                    console.error('Unable to look up resource URLs for DOIs');
                    console.error(err);
                });

    };

    // ----
    // Initialization functions
    // ----
    ns.init = function () {
        ns.mobileContentNav();
        ns.scrollHighlight();
        ns.toggleRelatedContentWidget('.related-content__view-more', '.related-content__hidden-wrap');

        // Initialize conference browse by year widget
        if ($('.widget-ConferencesBrowseByYear').length) {
            Theme.ConferencesBrowseByYear && Theme.ConferencesBrowseByYear.init && Theme.ConferencesBrowseByYear.init();
        }
    };

    ns.windowLoadInit = function () {
        ns.contentModals();
    };

    ns.ajaxCompleteInit = function () {
    };

})(App.SiteJS = App.SiteJS || {}, jQuery);


// ----
// Where all modules get initialized
// ----
// A closure around doc.ready, window.load, window resize, and Ajax Complete so we can safely use $
(function ($, undefined) {

    // Document Ready Event: DOM fully loaded
    $(document).ready(function () {
        App.SiteJS.init(); // init general JS module for site
        //App.PDFAccess.init(); // init PDF module from scm.sharedcontrols.pdfaccess.js
        if ($('body').hasClass('pg_Chapter') === true) {
            // theme client.script.js file will initialize splitscreen js only for article page. 
            // as we do splitscreen for chapter as well, we are calling init explictly for it.
            SCM.SplitScreen.init();
        }
    });

    // Window Load Event: Images done loading
    $(window).on('load', function () {
        App.SiteJS.windowLoadInit();
    });

    // Window Resize Event
    $(window).on('resize', function () {
        // all functions contained within the the resize event should be throttled or debounced in some way.
        // see the debounce function located in App.JSUtility.js
    });

    // Ajax Complete Event
    $(document).ajaxComplete(function (event, xhr, settings) {
        // init foundation for new DOM elements after new HTML loaded through AJAX
        App.SiteJS.ajaxCompleteInit();

        if ($('.pg_articlesplitview').length) {
            App.SiteJS.registerTrendMdOnSplitview();
        }

        if ($('.js-splitview-ref-list').length && !App.SiteJS.isGeoScienceWorldLinksCalled()) {
            App.SiteJS.insertGeoScienceWorldLinksIntoReferences();
        }
    });


})(jQuery);
